import isProd from './isProduction.ts'
import { HEADING } from './defaults'

export const endpoints = (prod = isProd()) => ({
  authApiUrl: prod ? 'https://writing.chegg.com/api/auth' : 'https://writing.test.cheggnet.com/api/auth',
  editorBaseUrl: prod ? 'https://writing.chegg.com' : 'https://writing.test.cheggnet.com',
})

export const CHEGG_SIHP_SUBHEADING = 'Wipe out plagiarism & grammar errors in your writing'

const cheggsihp = ({
  site = 'chegg',
  headingText = HEADING,
  subheadingText = CHEGG_SIHP_SUBHEADING,
  pasteOnly = true,
  alignText = 'left',
  initRSW = true,
  initFreshToken = true,
} = {}) => {
  const { authApiUrl, editorBaseUrl } = endpoints()

  return {
    headingText,
    subheadingText,
    authApiUrl,
    editorBaseUrl,
    pasteOnly,
    alignText,
    site,
    initFreshToken,
    initRSW,
  }
}

export default cheggsihp
